import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import type { LearningCoachApplicationRequest } from "../../../domains/LearningCoachApplicationRequestStatus";
import { createError } from "../../../errors";

const path =
  "/api/v1/sections/{section_id}/learning_coach/application_requests" as const;

// 申込一覧のクエリのキー。申込 URL を発行した後に一覧を取り直すときも、このキーを使う
export const learningCoachApplicationRequestsQueryKey = (sectionId: string) =>
  [path, sectionId] as const;

// 申込一覧は画面を開いたときに取得する。状態の絞り込みは取得済みの一覧の中で行う（LIST-01）。
// boron が lc へ照会する API のため、フォーカス復帰での取り直しと自動の再試行はしない
// （失敗したら画面で再読み込みを促す）
export const useFetchLearningCoachApplicationRequests = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  return useQuery<LearningCoachApplicationRequest[]>({
    queryKey: learningCoachApplicationRequestsQueryKey(sectionId),
    queryFn: async () => {
      const { response, data } = await boronClient.GET(path, {
        params: { path: { section_id: sectionId } },
      });
      if (response.ok && data) {
        return data.applicationRequests;
      }
      throw await createError(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
  });
};
